// src/pages/UiSample.js
import React from 'react';
import Button from 'components/atoms/Button/Button';
import { Link } from 'react-router-dom';
import { Input } from 'components/atoms/Input/Input';
import { Dropdown, DropdownOption } from 'components/atoms/Dropdown/Dropdown';
import { Icon } from 'icons'
import { routeConfigs } from '@/routes/routeConfigs';

const countryOptions: DropdownOption[] = [
    { value: 'kr', label: '대한민국' },
    { value: 'us', label: '미국' },
  ];

const UiSample = () => {
  return (
    <main>
    <h1 className="mb-4 text-2xl font-bold">현재 등록된 라우트</h1>
      <ul className="flex flex-wrap gap-5 pl-5 space-y-2 *:px-5 *:py-2 *:bg-white *:rounded-lg *:border *:border-gray-200 gap-y-2">
        {routeConfigs.map(({ path, name }) => (
          <li key={path}>
            <Link to={path} className="text-indigo-600 hover:underline">
              {name} — <code>{path}</code>
            </Link>
          </li>
        ))}
      </ul>
        <div>
        <Icon name="arrowDown" size={16} style={{ marginLeft: 8 }} />    
        <p className='text-lg font-bold'>크기</p>
        <Button size="small">스몰 버튼</Button>
       <Button>기본 버튼</Button>
        <Button size="large">스몰 버튼</Button>
        </div>
        
        <div>
            <p className='text-lg font-bold'>indents</p>
            <Button>기본 버튼</Button>
            <Button intent='secondary'>세컨더리</Button>
            <Button intent='danger'>댄져</Button>
        </div>

        <div className='mt-4'>
            <Button outline>기본 버튼</Button>
            <Button outline intent='secondary'>세컨더리</Button>
            <Button outline intent='danger'>댄져</Button>
        </div>

        <div className='mt-4'>
        <p className='text-lg font-bold'>댄져 모음</p>
        <Button size='small' intent='danger' disabled >댄져</Button>
        <Button intent='danger'>댄져</Button>
        <Button size='large' intent='danger'>댄져</Button>
        <Button size='small' intent='danger' outline>댄져</Button>
        <Button intent='danger' outline>댄져</Button>
        <Button size='large' intent='danger' outline>댄져</Button>
        </div>

        
        <div className='p-8 mt-10 rounded-lg border border-gray-200'>
            <h1 className='text-lg font-bold'>인풋</h1>
        <p className='mt-5 text-sm text-gray-500'>disabled</p>
        <Input
        id="phone"
        label="전화번호"
        placeholder='전화번호를 입력하세요'
        value={'010-1234-5678'}
        disabled
      />

        <p className='mt-5 text-sm text-gray-500'>default</p>
        <Input
        id="phone"
        label="전화번호"
        placeholder='전화번호를 입력하세요'
        value={'010-1234-5678'}
        readOnly
      />

    <p className='mt-5 mb-1 text-sm text-gray-500'>라벨 없음</p>
    <Input 
    placeholder='전화번호를 입력하세요'
    readOnly
    />
    </div>

    <div className='p-8 mt-10 rounded-lg border border-gray-200'>
        <h1 className='text-lg font-bold'>셀렉트</h1>
        <div className="w-64">
        <Dropdown
           options={countryOptions}
           placeholder="국가를 선택하세요"
           onChange={(value) => console.log(value)}
        />

        </div>

<Input 
    placeholder='전화번호를 입력하세요'
    readOnly
    />    <Input 
    placeholder='전화번호를 입력하세요'
    readOnly
    />
        <Input 
    placeholder='전화번호를 입력하세요'
    readOnly
    />

    </div>


   
    
        
    </main>
  );
};

export default UiSample;